import { AccountDisabledNotification } from 'src/components/common/AccountDisabledNotification';
import { AccountInactiveNotification } from 'src/components/common/AccountInactiveNotification';
import { useCatalogDataContext } from 'src/contexts/CatalogDataContext';
import { CatalogMultiSelectionContextProvider } from 'src/contexts/CatalogMultiSelectionContext';
import { useContent } from 'src/contexts/ContentContext';
import { DialogProvider } from 'src/contexts/DialogContext/DialogContext';
import { MobileDrawerProvider } from 'src/contexts/MobileDrawerContext';
import { MobileSalesSortAndFilterContextProvider } from 'src/contexts/MobileSortAndFilterContext/MobileSalesSortAndFilterContext';
import { MultiSelectionContextProvider } from 'src/contexts/MultiSelectionContext';
import { PosSpinner } from 'src/core/POS/PosSpinner';
import { globalMobileWrapper } from 'src/core/themes/themeContract.css';
import { Stack } from 'src/core/ui';
import { LayoutContent } from 'src/navigations/LayoutContent';
import { ContentId } from 'src/utils/constants/contentId';

import { MainRoute } from '../../MainRoute';
import { EventFilterBar } from './components/EventFilterBar';
import { EventGroupedTiles } from './components/EventGroupedList';

export const SaleEventsMobile = () => {
  const routeTitle = useContent(ContentId.Sales);
  const { isLoading, eventsTransformed } = useCatalogDataContext();

  if (isLoading) {
    return <PosSpinner />;
  }

  return (
    <CatalogMultiSelectionContextProvider type="sale">
      <MultiSelectionContextProvider>
        <MobileSalesSortAndFilterContextProvider>
          <DialogProvider>
            <MobileDrawerProvider>
              <LayoutContent
                mainRoute={MainRoute.Sales}
                routeTitle={routeTitle}
              >
                <Stack
                  direction="column"
                  className={globalMobileWrapper}
                  style={{ height: '100%', width: '100%' }}
                >
                  <AccountDisabledNotification />
                  <AccountInactiveNotification />
                  <EventFilterBar />
                  <EventGroupedTiles eventsTransformed={eventsTransformed} />
                </Stack>
              </LayoutContent>
            </MobileDrawerProvider>
          </DialogProvider>
        </MobileSalesSortAndFilterContextProvider>
      </MultiSelectionContextProvider>
    </CatalogMultiSelectionContextProvider>
  );
};
